export default __webpack_public_path__ + "static/media/logo_sedaro_primary_white_stacked.44cb439b.png";